import "./SkeletonLoader.scss";

// TODO: "Loading content" is not translated.
function SkeletonLoader() {
  return (
    <div data-testid="skeleton-loader__testid" className="skeleton-loader col-md-8 col-sm-10 col-12" aria-busy="true" style={{ height: "inherit" }}>
      Loading content
    </div>
  );
}

export default SkeletonLoader;
